module.exports = __webpack_public_path__ + "static/media/quindio-53.efb5b0bc.jpg";